import { Button } from '@driftt/tide-core'
import {
  ModalBody,
  ModalFooter,
  ModalTitle,
  useCloseModal,
} from '@driftt/tide-modal'
import React from 'react'

const StartExperimentModal = ({ onStartExperiment }) => {
  const handleCloseModal = useCloseModal()

  const handleConfirmClick = () => {
    onStartExperiment()
    handleCloseModal()
  }

  return (
    <>
      <ModalTitle>Your A/B test is about to start!</ModalTitle>
      <ModalBody>
        50% of targeted visitors will receive bot flow A and 50% of targeted
        visitors will receive bot flow B.
      </ModalBody>
      <ModalFooter>
        <Button onClick={handleConfirmClick}>Let's go!</Button>
        <Button
          type="tertiary"
          style={{ marginLeft: 8 }}
          onClick={handleCloseModal}
        >
          Cancel
        </Button>
      </ModalFooter>
    </>
  )
}

export default StartExperimentModal
